import api from './api';

export const getEnforcementLocationsDetailsAPI = async ({ payload }) =>
  api({ url: '/enforcement-lite/get-locations-details/', method: 'post', payload });

export const createEnforcementLiteLocationAPI = async ({ payload }) =>
  api({ url: '/enforcement-lite/create-new-location/', method: 'post', payload });

export const getUnassignedLightningPayLocationsAPI = async () =>
  api({ url: '/enforcement-lite/get-unassigned-lightning-pay-locations/', method: 'get' });

export const getEnforcementLiteLocationDetailsAPI = async (locationId) =>
  api({ url: `/enforcement-lite/get-location-details/${locationId}`, method: 'get' });

export const updateEnforcementLiteLocationAPI = async ({ payload }) =>
  api({ url: '/enforcement-lite/update-location-details/', method: 'post', payload });

export const getEnforcementLiteUsersAPI = async () => api({ url: '/enforcement-lite/get-users/', method: 'get' });

export const getEnforcementLiteUserDetailsAPI = async (userId) =>
  api({ url: `/enforcement-lite/get-user-details/${userId}`, method: 'get' });

export const updateEnforcementLiteUserAPI = async ({ payload }) =>
  api({ url: '/enforcement-lite/update-user-details/', method: 'post', payload });

export const createEnforcementLiteUserAPI = async ({ payload }) => api({ url: '/enforcement-lite/create-user/', method: 'post', payload });

export const getAllEnforcementLocationsDetailsAPI = async () => api({ url: '/enforcement-lite/get-all-locations-details/', method: 'get' });

export const deleteEnforcementLiteUserAPI = async ({ userId }) =>
  api({ url: '/enforcement-lite/delete-user/', method: 'post', payload: { userId } });

export const checkEnforcementLiteAvailabilityAPI = async () => api({ url: '/enforcement-lite/check-availability/', method: 'get' });
